var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 6.2334C11.6716 6.2334 11 6.90497 11 7.7334V11.7334C11 12.5618 11.6716 13.2334 12.5 13.2334H24.6667C25.4951 13.2334 26.1667 12.5618 26.1667 11.7334V7.7334C26.1667 6.90497 25.4951 6.2334 24.6667 6.2334H12.5ZM12.5 15.5667C11.6716 15.5667 11 16.2383 11 17.0667V21.0667C11 21.8952 11.6716 22.5667 12.5 22.5667H24.6667C25.4951 22.5667 26.1667 21.8952 26.1667 21.0667V17.0667C26.1667 16.2383 25.4951 15.5667 24.6667 15.5667H12.5Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 2.83334,
    y: 6.2334,
    width: 5.83333,
    height: 16.3333,
    rx: 1,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverview);
export default __webpack_public_path__ + "static/media/overview.b809c2e0d324704bff91b620785e9344.svg";
export { ForwardRef as ReactComponent };